import BankIcon from '@perpay-web/fintech/assets/images/icons/bank-icon.svg';

import AccountDisplay from './AccountDisplay';

/**
 * Represents a bank account object
 * @typedef {Object} BankAccount
 * @property {string} uuid - Unique identifier for the bank account
 * @property {string} bankName - Name of the bank
 * @property {string} [nickname] - Nickname of the bank account
 * @property {string} account - Account number
 * @property {string} routing - Routing number
 * @property {string} status - Status of the bank account
 */

/**
 * Renders a bank account display with a change button
 * @param {Object} props - Component props
 * @param {BankAccount} props.bankAccount - The bank account to display (required)
 * @param {Function} [props.onChange] - The function to call when the change button is clicked
 * @param {string} [props.prefix] - The prefix to display before the bank account name
 * @param {boolean} [props.loading] - Whether to show loading skeleton instead of content
 * @returns {JSX.Element} The rendered bank account display
 */
const BankAccountDisplay = ({ bankAccount, onChange, prefix, loading }) => (
    <AccountDisplay
        icon={BankIcon}
        title={bankAccount ? bankAccount.nickname || bankAccount.bankName : ''}
        subtitle={`Account •• ${bankAccount ? bankAccount.account : ''}`}
        showChange={!!onChange}
        onChange={onChange}
        prefix={prefix}
        loading={loading}
    />
);

export default BankAccountDisplay;
